import { render, staticRenderFns } from "./ControlWidgets.vue?vue&type=template&id=497ef618&scoped=true"
import script from "./ControlWidgets.vue?vue&type=script&lang=js"
export * from "./ControlWidgets.vue?vue&type=script&lang=js"
import style0 from "./ControlWidgets.vue?vue&type=style&index=0&id=497ef618&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497ef618",
  null
  
)

export default component.exports